import resource from './resource';
import store from '../store';

/**
 * Tacks on the server host name if it's a relative link.
 *
 * @param {*} href
 * @returns
 */
function getTargetHref(href) {
  if (!href || href.indexOf('http') >= 0) {
    return href;
  }
  else {
    const env = store.getters['content/environment'];
    return `${env.WEB_URL_HOST}${env.WEB_URL_ROOT}/${href}`;
  }
}

/**
 * Builds the full link to use for the a tag to link out to.
 *
 * @param {*} href    The link to go to
 * @param {*} src     A name for the source, usually the route name
 * @returns
 */
function getDestination(href, src) {
  const targetHref = getTargetHref(href);
  const queryString = resource.getQueryString({
    queryParams: {
      link: targetHref,
      src
    }
  });
  return `${resource.apiHost}${resource.BASE_API_PATH}/w/link${queryString}`;
}

/**
 * Replaces the href link in a text (usually a footnote) with our tracking link to redirect to the href
 *
 * @param {*} text    The text to process and replace the href link in.
 * @param {*} source  The source of the text, usually the route name.
 * @returns
 */
function processHrefInText(text, source) {
  let toReturn = text;
  const regEx = /href=['|"](.+?)['|"]/gm;
  let regexNext = null;

  while (null !== (regexNext = regEx.exec(toReturn))) {
    toReturn = toReturn.replace(regexNext[1], getDestination(regexNext[1], source));
  }
  return toReturn;
}

/**
 * Common tracking related utility functions that can be used throughout the app
 */
export default {
  getDestination,
  processHrefInText
};